import { createContext, useContext } from 'react';

import type { ReportingPeriod } from '@/features/datahub/periods/types';

export interface PeriodRange {
  /** ISO date string for the start of the range (e.g. "2026-01-01") */
  dateFrom: string;
  /** ISO date string for the end of the range (e.g. "2026-12-31") */
  dateTo: string;
}

export interface GHGPagePeriodContextValue {
  periodId: string;
  period: ReportingPeriod | null;
  periods: ReportingPeriod[];
  setPeriodId: (id: string) => void;
  isLoading: boolean;
  /** Internal key for the selected period option (e.g. "2026-m3") */
  selectedKey: string;
  /** Set the selected period option key directly */
  setSelectedKey: (key: string) => void;
  /** When set, view data across a date range instead of a single period */
  periodRange: PeriodRange | null;
  /** Set or clear period range */
  setPeriodRange: (range: PeriodRange | null) => void;
}

export const GHGPagePeriodContext = createContext<GHGPagePeriodContextValue | null>(null);

export function useGHGPagePeriod(): GHGPagePeriodContextValue {
  const ctx = useContext(GHGPagePeriodContext);
  if (!ctx) {
    throw new Error('useGHGPagePeriod must be used within a GHGPeriodProvider');
  }
  return ctx;
}
